const DataTableDescription = ({ children }) => {
  return <p className="mt-2 text-sm text-ink-700">{children}</p>;
};

export default DataTableDescription;
